import { gql } from "@apollo/client";
import { EMAIL_BRAND_THEME_FIELDS, EMAIL_TEMPLATE_FIELDS, TRAVEL_AIRLINE_FIELDS } from "./fragments";

export const CREATE_TRAVEL_EMAIL_TEMPLATE = gql`
  mutation CreateTravelEmailTemplate($request: NotificationTemplateRequestInput!) {
    createTravelEmailTemplate(request: $request) {
      ${EMAIL_TEMPLATE_FIELDS}
    }
  }
`;

export const UPDATE_TRAVEL_EMAIL_TEMPLATE = gql`
  mutation UpdateTravelEmailTemplate($id: String!, $request: NotificationTemplateRequestInput!) {
    updateTravelEmailTemplate(id: $id, request: $request) {
      ${EMAIL_TEMPLATE_FIELDS}
    }
  }
`;

export const SET_TRAVEL_EMAIL_TEMPLATE_ACTIVE = gql`
  mutation SetTravelEmailTemplateActive($id: String!, $isActive: Boolean!) {
    setTravelEmailTemplateActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const DELETE_TRAVEL_EMAIL_TEMPLATE = gql`
  mutation DeleteTravelEmailTemplate($id: String!) {
    deleteTravelEmailTemplate(id: $id)
  }
`;

export const SEND_TRAVEL_EMAIL_TEMPLATE_TEST = gql`
  mutation SendTravelEmailTemplateTest($id: String!, $locale: String!, $email: String!, $saleOrderCode: String) {
    sendTravelEmailTemplateTest(id: $id, locale: $locale, email: $email, saleOrderCode: $saleOrderCode) {
      id
      sent
      missingVariables
    }
  }
`;

export const UPLOAD_TRAVEL_EMAIL_TEMPLATE_IMAGE = gql`
  mutation UploadTravelEmailTemplateImage($file: Upload!) {
    uploadTravelEmailTemplateImage(file: $file) {
      url
    }
  }
`;

export const UPDATE_TRAVEL_EMAIL_BRAND_THEME = gql`
  mutation UpdateTravelEmailBrandTheme($request: NotificationBrandThemeRequestInput!) {
    updateTravelEmailBrandTheme(request: $request) {
      ${EMAIL_BRAND_THEME_FIELDS}
    }
  }
`;

export const UPSERT_TRAVEL_AIRLINE = gql`
  mutation UpsertTravelAirline($request: TravelAirlineRequestInput!) {
    upsertTravelAirline(request: $request) {
      ${TRAVEL_AIRLINE_FIELDS}
    }
  }
`;
